<template>
  <div class="c-entrepreneur-parallax">
    <div class="c-entrepreneur-parallax__inner">
      <!-- small img -->
      <entrepreneur-parallax-small :data="data.primary" />
      <!-- large img -->
      <entrepreneur-parallax-large :data="data.primary" />
    </div>
  </div>
</template>

<script>
import EntrepreneurParallaxLarge from "components/EntrepreneurParallax/EntrepreneurParallaxLarge";
import EntrepreneurParallaxSmall from "components/EntrepreneurParallax/EntrepreneurParallaxSmall";
export default {
  components: {
    EntrepreneurParallaxSmall,
    EntrepreneurParallaxLarge
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.c-entrepreneur-parallax {
  @include sharedParentBody;
  padding-top: var(--grid-gutter-double); // add a bit of padding to compensate the paralax effect
  @media #{$breakpoint-horizontal} {
    padding-top: 0px;
  }

  &__inner {
    display: flex;
    flex-direction: column;

    @media #{$breakpoint-horizontal} {
      flex-direction: row;
      height: 100%;
    }
  }
}
</style>
